import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  PopoverOrigin,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import { SelectItem } from "../../utils/utils";
import Flex from "../Flex";
import InfoIcon from "@mui/icons-material/Info";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Text from "../Text";

interface CustomActionMenuProps {
  options: Array<SelectItem & { isDisabled?: boolean; hoverMsg?: string }>;
  onActionClick: (v: string) => void;
  pos?: PopoverOrigin;
}

/**
 * Design to handle the action icon for tables
 * @important need to pass options only
 *
 * @author rajkumar rathod
 */
const ActionMenu = ({
  options,
  onActionClick,
  pos = { horizontal: "center", vertical: "top" },
}: CustomActionMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const close = () => setAnchorEl(null);

  const isVisitNotePage = window.location.pathname.includes("/visit-note");
  const isSingleView = isVisitNotePage && options[0]?.value === "view";

  if (isSingleView) {
    const viewOption = options[0];
    return (
      <Tooltip
        title={
          viewOption?.isDisabled ? viewOption?.hoverMsg : viewOption?.label
        }
        arrow
        placement="right"
      >
        <div>
          <Flex alignItems={"center"} justifyContent={"center"}>
            <IconButton
              size="small"
              disabled={viewOption?.isDisabled}
              onClick={(e) => {
                e.stopPropagation();
                onActionClick(viewOption.value);
              }}
            >
              <VisibilityOutlinedIcon fontSize="small" />
            </IconButton>
          </Flex>
        </div>
      </Tooltip>
    );
  }

  if (isVisitNotePage && options?.[0]?.value !== "view") return;

  return (
    <Flex alignItems={"center"} justifyContent={"center"}>
      <MoreVertIcon
        fontSize="small"
        sx={{
          cursor: "pointer",
        }}
        onClick={(e) => {
          setAnchorEl(e.currentTarget as any);
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={close}
        transformOrigin={pos}
      >
        {options?.map((it) => (
          <Tooltip
            title={it?.isDisabled && it?.hoverMsg}
            arrow
            placement="right"
          >
            <Box>
              <MenuItem
                disabled={it?.isDisabled}
                selected={it?.selected}
                key={it.value}
                onClick={(e) => {
                  e.stopPropagation();
                  close();
                  onActionClick(it.value);
                }}
              >
                <Text isTabletext>{it.label}</Text>
                {it?.isDisabled && (
                  <InfoIcon sx={{ fontSize: "16px", marginLeft: "2px" }} />
                )}
              </MenuItem>
            </Box>
          </Tooltip>
        ))}
      </Menu>
    </Flex>
  );
};

export default ActionMenu;
